<template>
	<PopupRouterView label="Purchase Order Status Input"  entityName="documentcategory" :documentId="mainRecordId"  @saveMethod="saveAction" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData" />
			</b-col>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DocumentCategory from '@/models/DocumentCategory/DocumentCategory';
import DocumentCategoryList from '@/models/DocumentCategory/DocumentCategoryList';
import DocumentCategoryFilter from '@/filters/DocumentCategory/DocumentCategoryFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,PopupRouterView},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDocumentCategory : null,
			currentDocumentCategoryPage : 1,
			documentCategoryPageSize: 10,
			sortByDocumentCategory: '',
			sortDescDocumentCategory: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getDocumentCategory : async function(id) {
			this.isBusy = true;
			DocumentCategory.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDocumentCategory = true;
			this.filterDocumentCategory.id = this.modelId;
			DocumentCategory.downloadDataDetail(this, this.filterDocumentCategory).then(result => {
				this.isDownloadDocumentCategory = false;
			}).catch(error => { this.isDownloadDocumentCategory = false; })
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					DocumentCategory.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'documentcategoryindex' });
						this.isBusy = false;
						this.$store.dispatch('addSuccessMessageGlobal', "Data Berhasil disimpan");
					}).catch(error => { this.isBusy = false; });
				} else {
					DocumentCategory.insertData(this, model).then(result => {
						this.$router.push({ name: 'documentcategoryindex' });
						this.isBusy = false;
						this.$store.dispatch('addSuccessMessageGlobal', "Data Berhasil disimpan");
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			/*Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DocumentCategory.updateData(this, model, id);
				}
			});*/
		},
		onHidden() {
			this.getDocumentCategorys();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDocumentCategory = new DocumentCategoryFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDocumentCategory(id);
			} else {
				this.modelId = id;
				this.getDocumentCategory(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
		if (!this.isDataCommited) {
			//DocumentCategory.discardData(this, this.modelId);
		}
	},
}
</script>
